/**
 * Cloudflare R2 behind the common interface.
 *
 * Kept for people who want real object storage: 10 GB free, free egress, and
 * keys that never expire. It is not one-click and cannot be made so — the
 * Cloudflare API sends no CORS headers, so a browser cannot create the bucket
 * or set the CORS policy on the user's behalf.
 */
import { putObject, getObject, deleteObject, type R2Config } from '../r2';
import type { ProviderMeta, StorageBackend } from './types';

export const r2Meta: ProviderMeta = {
  id: 'r2',
  name: 'Cloudflare R2',
  blurb: 'Object storage you control. Needs a few minutes of setup.',
  free: '10 GB free',
  auth: 'keys',
  durability: {
    lasts: 'indefinite',
    note: 'R2 access keys do not expire.',
  },
};

const PREFIX = 'aliveguardian';

export function r2Backend(cfg: R2Config): StorageBackend {
  return {
    async put(path, body) {
      await putObject(cfg, `${PREFIX}/${path}`, body as BufferSource);
      return { size: body.byteLength };
    },
    async get(path) {
      const buf = await getObject(cfg, `${PREFIX}/${path}`);
      return buf ? new Uint8Array(buf) : null;
    },
    async remove(path) {
      await deleteObject(cfg, `${PREFIX}/${path}`);
    },
  };
}
